

export class TourOutputWithStatus implements ITourOutputWithStatus {
    /** The auto-generated id of the tour master */
    tour_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The branch name with 255 character */
    branch!: string;
    /** The start point 5000 character limit */
    start_point!: string;
    /** The start point 5000 character limit */
    end_point!: string;
    /** The distance */
    distance!: number;
    /** The duration 10 character limit */
    duration!: string;
    /** The tour name 255 character limit */
    tour_name!: string;
    /** Total point path */
    total_stop_point!: string;
    /** The status of poi details should be 0 or 1 */
    status!: number;

    constructor(data?: ITourOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_id = _data["tour_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.start_point = _data["start_point"];
            this.end_point = _data["end_point"];
            this.distance = _data["distance"];
            this.duration = _data["duration"];
            this.tour_name = _data["tour_name"];
            this.total_stop_point = _data["total_stop_point"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TourOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TourOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_id"] = this.tour_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["start_point"] = this.start_point;
        data["end_point"] = this.end_point;
        data["distance"] = this.distance;
        data["duration"] = this.duration;
        data["tour_name"] = this.tour_name;
        data["total_stop_point"] = this.total_stop_point;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITourOutputWithStatus {
    /** The auto-generated id of the tour master */
    tour_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The branch name with 255 character */
    branch: string;
    /** The start point 5000 character limit */
    start_point: string;
    /** The start point 5000 character limit */
    end_point: string;
    /** The distance */
    distance: number;
    /** The duration 10 character limit */
    duration: string;
    /** The tour name 255 character limit */
    tour_name: string;
    /** Total point path */
    total_stop_point: string;
    /** The status of poi details should be 0 or 1 */
    status: number;
}

